import Cookies from 'js-cookie'

import { SESSION } from 'src/constant'

export const getGuruToken = (): string | null => {
  const userSession = Cookies.get(SESSION.USER_SESSION)
  if (!userSession) return null

  const { guruToken } = JSON.parse(userSession)
  return guruToken ?? null
}
